import type { CSSProperties } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Ic from "../icons.jsx";

/**
 * Shared tabla|lista|levak tabs.
 * Board and list live on separate routes (/offers, /offers/list) — the
 * search text is the one filter criterion kept in sync across them via the
 * `q` URL param, so switching views doesn't lose what the user typed (see
 * offersFilter.ts's OfferFilterCriteria.search). The other filters
 * (stage/country/date/owner) intentionally reset per view: a stage filter,
 * for one, is largely redundant with the board's own column layout.
 *
 * "Levak" (funnel, /offers/funnel). Unlike board/list it doesn't carry `q` forward: the funnel
 * endpoint has no search/filter params (a single server-side aggregate), so
 * there's nothing for the text to scope there.
 */
export function OffersViewSwitcher({ active, search }: { active: "board" | "list" | "funnel"; search: string }) {
  const { t } = useTranslation();
  const qs = search ? `?q=${encodeURIComponent(search)}` : "";
  return (
    <div style={row}>
      <Link
        to={`/offers${qs}`}
        className={active === "board" ? "btn primary sm" : "btn sm"}
        style={active !== "board" ? { textDecoration: "none" } : undefined}
      >
        <Ic.grid /> {t("offers.view.board")}
      </Link>
      <Link
        to={`/offers/list${qs}`}
        className={active === "list" ? "btn primary sm" : "btn sm"}
        style={active !== "list" ? { textDecoration: "none" } : undefined}
      >
        <Ic.list /> {t("offers.view.list")}
      </Link>
      <Link
        to="/offers/funnel"
        className={active === "funnel" ? "btn primary sm" : "btn sm"}
        style={active !== "funnel" ? { textDecoration: "none" } : undefined}
      >
        <Ic.trend /> {t("offers.view.funnel")}
      </Link>
    </div>
  );
}

const row: CSSProperties = { display: "flex", gap: 6 };
